/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    MoyaComponents.register('extras.filter', function (el) {
        var filterController = new FilterController(el, el.querySelector('.cards__container__wrap'), 'filters');
        var filterButtons = [];
        el.querySelectorAll('.filter-button').forEach(function (buttonElement) {
            filterButtons.push(new FilterButton(buttonElement, filterController, 'filters'));
        });
        var tagController = new FilterController(el, el.querySelector('.cards__container__wrap'), 'tags');
        var tagButtons = [];
        el.querySelectorAll('.tag-button').forEach(function (buttonElement) {
            tagButtons.push(new FilterButton(buttonElement, tagController, 'tags'));
        });
        addPaginationListeners();
        addYearFilterListeners();
        function addPaginationListeners() {
            el.querySelectorAll('.paginationControl .pagerContent > a').forEach(function (paginationButton) {
                paginationButton.addEventListener('click', function (event) {
                    event.preventDefault();
                    filterController.changePage(paginationButton);
                });
            });
        }
        function addYearFilterListeners() {
            el.querySelector('.years > select').addEventListener('change', function (ev) {
                var url = ev.currentTarget.getAttribute('data-url');
                filterController.setYear(parseInt(ev.currentTarget.value));
                filterController.updateParams();
                filterController.replaceData(url);
            });
        }
    });
    var FilterController = /** @class */ (function () {
        function FilterController(el, replaceEl, paramName) {
            this.el = el;
            this.replaceEl = replaceEl;
            this.paramName = paramName;
            this.selectedFilterIds = [];
            this.year = null;
            this.init();
        }
        FilterController.prototype.init = function () {
            var params = new URLSearchParams(location.search);
            var filterQueryValue = params.get(this.paramName);
            this.selectedFilterIds = filterQueryValue ? filterQueryValue.split('|').map(function (item) { return parseInt(item); }) : [];
        };
        FilterController.prototype.delegateClick = function (button) {
            button.getSelected() ? this.addFilterValue(button.getId()) : this.removeFilterValue(button.getId());
            this.updateParams();
            this.replaceData(button.getUrl());
        };
        FilterController.prototype.updateParams = function () {
            var params = new URLSearchParams(location.search);
            params.set(this.paramName, this.selectedFilterIds.join('|'));
            params.set('page', '1');
            params.set('year', (isNaN(this.year) || !this.year) ? '' : this.year.toString());
            window.history.replaceState('', '', '?' + params.toString());
        };
        FilterController.prototype.addFilterValue = function (filterId) {
            if (this.selectedFilterIds.includes(filterId)) {
                return;
            }
            this.selectedFilterIds.push(filterId);
        };
        FilterController.prototype.replaceData = function (url) {
            var _this = this;
            var query = new URLSearchParams(location.search);
            query.set('lazy', 'true');
            MoyaContainer.get('core.fetch').fetchAndReplace({
                url: url + '?' + query.toString(),
            }, this.replaceEl.children.item(0))
                .then(function (el) {
                _this.addPaginationListeners(el);
                el.classList.remove('loading');
                var box = el.closest('.box');
                if (box) {
                    box.scrollIntoView({ behavior: 'smooth' });
                }
                else {
                    _this.el.scrollIntoView({ behavior: 'smooth' });
                }
            });
        };
        FilterController.prototype.addPaginationListeners = function (el) {
            var _this = this;
            el.querySelectorAll('.paginationControl .pagerContent > a').forEach(function (paginationButton) {
                paginationButton.addEventListener('click', function (event) {
                    event.preventDefault();
                    _this.changePage(paginationButton);
                });
            });
        };
        FilterController.prototype.removeFilterValue = function (filterId) {
            if (!this.selectedFilterIds.includes(filterId)) {
                return;
            }
            this.selectedFilterIds = this.selectedFilterIds.filter(function (element) {
                return element !== filterId;
            });
        };
        FilterController.prototype.setYear = function (year) {
            this.year = year;
        };
        FilterController.prototype.changePage = function (paginationButton) {
            var href = paginationButton.getAttribute('href');
            var search = href.substr(href.search(/\?.*/) > -1 ? href.search(/\?.*/) : href.length, href.length);
            if (!search) {
                search = '?page=1';
            }
            var url = href.substr(0, href.search(/\?.*/) > -1 ? href.search(/\?.*/) : href.length);
            var paginationButtonSearchParams = new URLSearchParams(search);
            var currentSearchParams = new URLSearchParams(location.search);
            currentSearchParams.set('page', paginationButtonSearchParams.get('page'));
            window.history.replaceState('', '', '?' + currentSearchParams.toString());
            this.replaceData(url);
        };
        return FilterController;
    }());
    var FilterButton = /** @class */ (function () {
        function FilterButton(el, filterController, paramName) {
            this.el = el;
            this.filterController = filterController;
            this.paramName = paramName;
            this.filterId = parseInt(el.getAttribute('data-filter-value'));
            this.url = el.getAttribute('data-url');
            this.initSelected();
            this.addClickListener();
        }
        FilterButton.prototype.initSelected = function () {
            var _a;
            var query = new URLSearchParams(location.search);
            if ((_a = query.get(this.paramName)) === null || _a === void 0 ? void 0 : _a.split('|').map(function (val) { return parseInt(val); }).includes(this.filterId)) {
                this.toggleSelected();
            }
        };
        FilterButton.prototype.addClickListener = function () {
            this.el.addEventListener('click', this.getClickHandler(this));
        };
        FilterButton.prototype.getClickHandler = function (self) {
            return function (e) { return self.handleClick(e); };
        };
        FilterButton.prototype.getId = function () {
            return this.filterId;
        };
        FilterButton.prototype.getUrl = function () {
            return this.url;
        };
        FilterButton.prototype.getSelected = function () {
            return this.selected;
        };
        FilterButton.prototype.toggleSelected = function () {
            this.selected = !this.selected;
            if (this.selected) {
                this.el.classList.add('selected');
            }
            else {
                this.el.classList.remove('selected');
            }
        };
        FilterButton.prototype.handleClick = function (e) {
            e.stopPropagation();
            this.toggleSelected();
            this.filterController.delegateClick(this);
        };
        return FilterButton;
    }());

}());
typeof tsBuild === 'function' && tsBuild();})();
